var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLanguagePopup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 192 192",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M172 92c0-41.907-34.093-76-76-76S20 50.093 20 92s34.093 76 76 76c9.836 0 19.386-1.846 28.413-5.49L152 174.004l-.002-30.62C164.908 129.327 172 111.144 172 92zm-28 70.004l-19.611-8.17-1.556.668C114.347 158.15 105.32 160 96 160c-37.495 0-68-30.505-68-68s30.505-68 68-68 68 30.505 68 68c0 17.615-6.708 34.32-18.89 47.035l-1.112 1.16.002 21.81zM96 84a8 0 0 1 0 0 16 8  0 0 0 0-16zm-28 0a8 8 0 1 0 0 16 8 8 0 0 0 0-16zm56 0a8 8 0 1 0 0 16 8 8 0 0 0 0-16z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguagePopup);
export default __webpack_public_path__ + "static/media/languagePopup.0dd5677159bf603a8a84c923f1b82271.svg";
export { ForwardRef as ReactComponent };